<template>
    <div class="flowStatistics">
        <div class="todayStatistics">
            <div class="num"><span>03</span>人次</div>
            <div class="text">今日人流量统计</div>
        </div>
        <div class="todayStatistics todayStatistics2">
            <div class="num"><span>03</span>人次</div>
            <div class="text">今日车流量统计</div>
        </div>
        <div class="cumulativeStatistics">
            <div class="text">累计人流量统计</div>
            <div class="num"><span>567</span>人次</div>
        </div>
        <div class="cumulativeStatistics cumulativeStatistics2">
            <div class="text">累计车流量统计</div> 
            <div class="num"><span>567</span>人次</div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less" scoped>
.flowStatistics{
    position: absolute;
    top: 105px;
    left: 50%;
    transform: translateX(-50%);
    width: 865px;
    height: 170px;
    background: url(~@/assets/images/flowStatistics_bg.png) no-repeat;
    background-size: 100% 100%;
    .todayStatistics{
        position: absolute;
        top: 20px;
        left: 255px;
        color: #fff;
        .num{
            font-size: 14px; 
            text-align: center;
            span{
                font-size: 50px;
                color: rgba(255, 186, 112, 1);
                font-weight: bold;
            }
        }
        .text{
            font-size: 16px;
        }
    }
    .todayStatistics2{
        left: 497px;
    }
    
    .cumulativeStatistics{
        position: absolute;
        top: 35px;
        left: 40px;
        background: url(~@/assets/images/cumulativeStatistics.png) no-repeat;
        background-size: 100% 100%;
        width: 143px;
        height: 91px;
        color: #fff;
        .text{
            font-size: 14px;
            padding-left: 24px;
            padding-top: 2px;
            margin-bottom: 14px;
        }
        .num{
            font-size: 14px;
            text-align: center;
            span{
                font-size: 32px;
                color: rgba(5, 255, 251, 1);
            }
        }
    }
    .cumulativeStatistics2{
        left: 680px;
    }
}
</style>